import React, { useEffect } from 'react';
import styles from '../styles/KickoffCall.module.css';
import { Helmet } from 'react-helmet-async';

export default function KickoffCall() {
    useEffect(() => {
        const existingScript = document.querySelector(
            'script[src="https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js"]'
        );

        if (!existingScript) {
            const script = document.createElement('script');
            script.src =
                'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
            script.type = 'text/javascript';
            script.async = true;
            document.body.appendChild(script);
        }

        return () => { };
    }, []);

    return (
        <>
            <Helmet>
                <title>Book Kickoff Call | Meshae Studios</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <main className={styles.kickoffPage}>
                <section className={styles.heroSection}>
                    <div className={styles.pageGrid}>
                        <div className={styles.metaBlock}>
                            <p className={styles.kicker}>next step</p>
                            <p className={styles.micro}>meshae studios</p>
                        </div>

                        <div className={styles.titleBlock}>
                            <h1 className={styles.title}>
                                kickoff
                                <br />
                                call
                            </h1>
                        </div>

                        <div className={styles.copyBlock}>
                            <p className={styles.lead}>
                                Pick a time that works for you.
                            </p>
                            <p className={styles.description}>
                                This call is a simple first conversation. We’ll talk through your
                                goals, scope, timeline, and whether one of the current packages fits
                                or if a different approach makes more sense.
                            </p>
                        </div>
                    </div>
                </section>

                <section className={styles.embedSection}>
                    <div className={styles.pageGrid}>
                        <div className={styles.embedLabelBlock}>
                            <p className={styles.kicker}>schedule</p>
                        </div>

                        <div className={styles.embedStage}>
                            <div className={styles.embedFrame}>
                                <div
                                    className="meetings-iframe-container"
                                    data-src="https://meetings.hubspot.com/meshae/kickoff?embed=true"
                                />
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    );
}